import React, { Component } from 'react';
import {
	Link
} from 'react-router-dom';

class EachFileEgfr extends Component {
    render() {
    	return(
			<div className="file anim1 br5" style={{backgroundColor: (this.props.index % 2 === 0 ? '#FAFAFA' : '#FFFFFF')}}>
				<div className="row fileRow">
					<div className="rt" style={{width: '20%', float: 'left'}}><span className="mobileShowIB"><strong>Upload Date:</strong></span> {this.props.children.dateUpload}</div>
					<div className="rt" style={{width: '25%', float: 'left'}}><span className="mobileShowIB"><strong>File Name:</strong></span> {this.props.children.name.split("_")[0].slice(0, -4)}</div>
					<div className="rt" style={{width: '15%', float: 'left'}}><span className="mobileShowIB"><strong>File Type:</strong></span> {this.props.children.type}</div>
					<div className="rt" style={{width: '15%', float: 'left'}}><span className="mobileShowIB"><strong>Is eGFR Calculated:</strong></span> {Number(this.props.children.calculated) === 0 ? 'No' : 'Yes'}</div>
					<div className="rt" style={{width: '25%', float: 'left'}}>
						<span className="mobileShowIB"><strong>Actions:</strong></span>
						<Link style={{ marginTop: -4 }} className="fileLink" to={'/egfr/calculate/' + this.props.children.id}><span className="fas fa-fw fa-arrow-right"></span></Link>
					</div>
				</div>
			</div>
    	);
    }
}

export default EachFileEgfr;


// WEBPACK FOOTER //
// ./src/components/EachFileEgfr.js